import { BudgetApiClient } from '../api/client';
import { useAsync } from './useAsync';
import type { FilterMatrixRow, FilterMatrixResponse } from '../types';

export interface UseFilterMatrixResult {
  matrix: FilterMatrixRow[] | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

// Fetches the filter matrix once per `type`. The matrix only changes on
// deploy (data refresh), so the response is HTTP-cached aggressively
// upstream — this hook just re-runs when `type` flips.
export function useFilterMatrix(
  apiClient: BudgetApiClient,
  type: 'E' | 'A',
): UseFilterMatrixResult {
  const { data, error, isLoading, refetch } = useAsync<FilterMatrixResponse>(
    () => apiClient.getFilterMatrix(type),
    [apiClient, type],
  );
  return { matrix: data?.rows ?? null, isLoading, error, refetch };
}
